import React from "react";
import PropTypes from "prop-types";
import { FaCircle } from "react-icons/fa";
import { toTitleCase } from "@/utils/strings";

const Step4 = ({ requisitos }) => {
  return (
    <div className="mt-2 overflow-x-auto rounded-lg border border-gray-300">
      {requisitos && requisitos.length > 0 ? (
        <table className="w-full table-auto text-left text-sm">
          <thead className="bg-gray-100 font-semibold text-gray-700">
            <tr>
              <th className="px-4 py-2">Requisito</th>
              <th className="px-4 py-2">Estado</th>
            </tr>
          </thead>
          <tbody>
            {requisitos.map((req, index) => (
              <tr
                key={"req" + index}
                className="cursor-pointer hover:bg-gray-200"
              >
                {/* Nombre */}
                <td className="px-4 py-2">{toTitleCase(req.Nombre)}</td>

                {/* Estado */}
                <td className="px-4 py-2">
                  <span
                    className={`flex items-center gap-2 rounded-lg px-4 py-1 text-gray-700 ${
                      req.Valor ? "text-green-500" : "text-red-500"
                    }`}
                  >
                    <FaCircle />
                    {req.Valor ? "APROBADO" : "NEGADO"}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className="p-4 text-gray-600">No hay requisitos para mostrar.</p>
      )}
    </div>
  );
};

Step4.propTypes = {
  requisitos: PropTypes.arrayOf(
    PropTypes.shape({
      Detalle: PropTypes.array,
      Nombre: PropTypes.string.isRequired,
      Valor: PropTypes.bool.isRequired,
    }),
  ),
};

export default Step4;
